export const validEmptyField = (field, setError) => {
	if (!field) {
		setError(true);
		return false;
	}
	setError(false);
	return true;
};
